import { useState, useCallback } from 'react';

import { isPropControlled } from '../helpers';

function useVisibility({
  disabled,
  propsOverlayOpen,
  defaultOpen,
}: {
  disabled?: boolean;
  propsOverlayOpen?: boolean;
  defaultOpen?: boolean;
}): [boolean, () => void] {
  const [stateOverlayOpen, setStateOverlayOpen] = useState(defaultOpen);

  const open =
    !disabled &&
    (isPropControlled(propsOverlayOpen) ? propsOverlayOpen : stateOverlayOpen);

  const toggleOverlay = useCallback(
    () => setStateOverlayOpen((state) => !state),
    []
  );

  return [!!open, toggleOverlay];
}

export default useVisibility;
